import React from 'react';
import { TypeAnimation } from 'react-type-animation';
import Zoom from 'react-reveal/Zoom';
import res from '../../ass/Untitled-2.png'
const Banner = () => {
    return (
        <section id='home' className='mt-24 h-[90vh] flex justify-center items-center bg-cover relative bg-black' >
            <div className='bg-fixed h-[90vh] w-full bg-cover absolute' style={{backgroundImage: `url(${res})`}}></div>
            <Zoom cascade>
            <div className='justify-center flex flex-col items-center gap-5 text-white -mt-20'>
                <h1 className='lg:text-5xl text-3xl font-bold '>HEY I AM </h1>
                <h1 className='lg:text-5xl text-3xl font-bold'> RESALAT <span className='text-red-500'>ISLAM</span></h1>
                <div className='flex items-center lg:text-3xl text-2xl w-full'>
                        <p className='mr-3 text-gray-300'>Creative</p>
                    <TypeAnimation
                    sequence={[
                        'web developer',
                        2000,
                        'Front end developer', 
                        2000, 
                        'Backend developer',
                        2000,
                        ' ',
                        () => {
                            
                        }
                    ]}
                    
                    wrapper="div"
                    cursor={true}
                    repeat={Infinity}
                    />
                </div>
            </div>
            </Zoom>
        </section>
    );
};

export default Banner;